import { exhaustiveCheck } from '../../../../../shared/esm';

var useDeprecatedBadge = function () {
    var transformDeprecatedBadge = function (unsafeBadge) {
        switch (unsafeBadge) {
            case 'negative':
                return 'negative-cross';
            case 'positive':
                return 'positive-checkmark';
            case 'attention':
                return 'attention-alert';
            default:
                return exhaustiveCheck(unsafeBadge);
        }
    };
    return {
        transformDeprecatedBadge: transformDeprecatedBadge,
    };
};

export { useDeprecatedBadge };
